import React from "react";
import { Alert, Stack } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { OtpStep } from "../../../authentication/business-onboard/steps/OtpStep";

interface IVerifyOtpStepProps {
  otp: string;
  otpError: string | null;
  resendTimer: number;
  loading: boolean;
  onOtpChange: (value: string) => void;
  onResend: () => void;
}

/**
 * OTP entry for the billing-mode change. The code is delivered to the
 * registered owner's mobile number over WhatsApp.
 */
export const VerifyOtpStep: React.FC<IVerifyOtpStepProps> = ({
  otp,
  otpError,
  resendTimer,
  loading,
  onOtpChange,
  onResend,
}) => {
  return (
    <Stack spacing={2} sx={{ pt: 0.5 }}>
      <Alert icon={<WhatsAppIcon fontSize="inherit" />} severity="info">
        An OTP has been sent to the registered owner's mobile number via
        WhatsApp.
      </Alert>

      <OtpStep
        otp={otp}
        otpError={otpError}
        resendTimer={resendTimer}
        loading={loading}
        onOtpChange={onOtpChange}
        onResend={onResend}
      />
    </Stack>
  );
};
